const EXHIBITION_PRESENTATION_OPTIONS = [
  { label: "Private", value: 0 },
  { label: "Public", value: 1 },
];

const getExhibitionPresentationInput = ({
  disabled = false,
  submitOnBlur = false,
} = {}) => ({
  label: "Presentation",
  name: "channelPresentation",
  type: "multi-select",
  options: EXHIBITION_PRESENTATION_OPTIONS,
  isNullable: false,
  submitOnBlur,
  disabled,
});

export { EXHIBITION_PRESENTATION_OPTIONS, getExhibitionPresentationInput };
